import { ResourceIdentifier } from "../../ResourceManager/ResourceIdentifier";
import { FreegameBonus2, FreegameBonus2Params } from "./FreegameBonus2";
//import { FreegameConfiguration } from "./FreegameConfiguration";
import { FreegamesCommonConfiguration } from "../../api";
export  class FreegameBonusNoJackpot2_2Screen extends FreegameBonus2
{	
	public constructor(gameResid: ResourceIdentifier, freegameConfig: FreegamesCommonConfiguration, params: FreegameBonus2Params) {
		super(gameResid, freegameConfig, params)
	}		
}
